export default __webpack_public_path__ + "static/media/scan2.cda74c64.svg";